export function vertaal(tekstNl: string, tekstEn: string) {
    if (document.documentElement!.lang.toLowerCase().substring(0, 2) === "en") {
        return tekstEn;
    }
    return tekstNl;
}
